// extracted by mini-css-extract-plugin
export default {"dot":"CustomCursor_dot__vvTJd","ring":"CustomCursor_ring__SXRyE"};